<template>
    <router-link
        :to="{ name: 'playerMessage', params: { id: message.id } }"
        class="message"
        :class="{ read: !message.read, deleteOn: deleteOn }"
    >
        <header>
            <span class="from">{{ message.from.first_name }} {{ message.from.last_name }}</span>
            <span class="date">{{ $date(message.created_at).format("D MMM YYYY") }}</span>
        </header>

        <div class="copy">
            <p>{{ message.short_message }}</p>
        </div>

        <button
            @click.prevent="deleteMessage"
            v-if="deleteOn"
            class="button red"
            type="button"
            name="button"
        >
            <img class="minus" src="@/assets/minus.svg" />
        </button>
    </router-link>
</template>

<script>
export default {
    name: "",
    props: ["message", "deleteOn"],
    methods: {
        deleteMessage() {
            this.$confirm("Are you sure you want to delete this message?", () => {
                this.$emit("messageDeleted", this.message);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.message {
    background: white;
    padding: 15px;
    border-radius: 12px;
    margin-bottom: 10px;
    display: block;
    text-decoration: none;
    position: relative;

    &.deleteOn {
        padding-right: 73px;
    }

    &.read {
        border-left: 5px solid #60c45c;
    }

    header {
        color: $green_0;
        margin-bottom: 10px;
        .title {
            font-weight: bold;
        }
        .date {
            float: right;
            color: #939a93;
        }
    }
    .copy {
        color: $green_0;
        font-weight: 200 !important;
    }
    .offer {
        margin-top: 10px;
        display: block;
        color: $green_1;
    }

    button {
        position: absolute;
        top: 0px;
        width: 64px;
        height: 100% !important;
        right: 0px;
        border-radius: 0px;
        border-top-right-radius: $radius;
        border-bottom-right-radius: $radius;
        width: 64px;
        padding: 0px;
        .minus {
            margin-left: 7px;
        }
        &:before {
            content: "";
            width: 12px;
            background: blue;
            height: 100%;
            position: absolute;
            top: 0px;
            left: 0px;
            background: white;
            border-top-right-radius: $radius;
            border-bottom-right-radius: $radius;
        }
        &.sent {
            &:before {
                background: #e7efeb;
            }
        }
    }
}
</style>
